// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b346ce71","667":"c74d97d6","695":"3d60ed17"}[chunkId] + ".chunk.js";
};